module.exports = __webpack_public_path__ + "img/en_us.badcafd1.png";